import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pill-label usn pill-segment" }

import FilterIcon from './FilterIcon.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PillLabel',
  props: {
    iconName: { default: undefined },
    label: {},
    type: { default: '' },
    iconClass: { default: '' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.iconName)
      ? (_openBlock(), _createBlock(FilterIcon, {
          key: 0,
          "icon-name": _ctx.iconName,
          type: _ctx.type,
          "icon-class": `bg-icon-default ${_ctx.iconClass}`
        }, null, 8, ["icon-name", "type", "icon-class"]))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("span", {
      class: _normalizeClass({ 'ml-1': _ctx.iconName })
    }, _toDisplayString(_ctx.label), 3)
  ]))
}
}

})